(() => {
  if (window.NWCardHover) return;
  window.NWCardHover = true;
  const tracked = new WeakSet();
  function discover(root) {
    const images = root.matches?.('img.nw-hover-secondary') ? [root] : root.querySelectorAll?.('img.nw-hover-secondary') || [];
    for (const image of images) {
      const media = image.closest('.nw-hover-media');
      if (!media || media.matches('.psc-card__media') || tracked.has(image)) continue;
      tracked.add(image);
      const ready = async () => {
        if (!image.naturalWidth) return;
        try { await image.decode(); } catch { return; }
        if (image.isConnected) media.classList.add('nw-hover-ready');
      };
      image.addEventListener('load', ready);
      image.addEventListener('error', () => media.classList.remove('nw-hover-ready'));
      if (image.complete) ready();
    }
  }
  discover(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) discover(node);
  }).observe(document.body, { childList:true, subtree:true });
})();
